(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    // Pixels of travel required before a change of direction is believed.
    static SCROLL_DEADZONE = 8;

    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.measure = this.measure.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.frostArmed = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.measure);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.measure);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // The observer measures once and disconnects, so the bounds go stale the
    // moment anything above the fold changes height. Stale bounds make the
    // hide/reset threshold sit at the wrong scroll position, which reads as
    // flicker around that point. offsetTop is meaningless while the header is
    // fixed, so only re-measure when it isn't.
    measure() {
      this.setHeaderHeight();
      if (this.header.classList.contains('shopify-section-header-sticky')) return;
      const top = this.header.offsetTop;
      this.headerBounds = { top: top, bottom: top + this.header.offsetHeight };
    }

    onScroll() {
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      // Build the frosted layer once, on any scroll, and leave it in place.
      if (!this.frostArmed && scrollTop > 0) {
        this.frostArmed = true;
        this.header.classList.add('header-frost-armed');
      }

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.currentScrollTop = scrollTop;
        requestAnimationFrame(this.reset.bind(this));
        return;
      }

      if (scrollTop <= this.headerBounds.bottom) {
        this.currentScrollTop = scrollTop;
        return;
      }

      // Deadzone. A bare `scrollTop < currentScrollTop` treats one pixel of
      // reverse travel as a deliberate scroll up, and trackpads, momentum
      // decay and rubber-banding all produce that — so the header hid,
      // revealed and hid again within a few frames. Below the threshold
      // nothing happens AND currentScrollTop is left untouched, so slow
      // deliberate scrolling still accumulates past it rather than being
      // swallowed.
      const delta = scrollTop - this.currentScrollTop;
      if (Math.abs(delta) < StickyHeader.SCROLL_DEADZONE) return;

      this.header.classList.add('scrolled-past-header');

      if (delta > 0) {
        if (this.preventHide) return;
        this.currentScrollTop = scrollTop;
        requestAnimationFrame(this.hide.bind(this));
        return;
      }

      this.currentScrollTop = scrollTop;

      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
        return;
      }

      window.clearTimeout(this.isScrolling);

      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
      }, 66);

      requestAnimationFrame(this.hide.bind(this));
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      // Animate out only from a state where the header is on screen: pinned
      // and not already hidden. Arriving here straight from a scrolled-past
      // state, it is off-screen, and a transition would make it appear at the
      // top of the viewport just to slide back out.
      const onScreen =
        this.header.classList.contains('shopify-section-header-sticky') &&
        !this.header.classList.contains('shopify-section-header-hidden');
      this.header.classList.toggle('header-animate-out', onScreen);

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
        'header-animate-out'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // Basket pill. The cart scripts replace #cart-icon-bubble's contents
  // wholesale after a cart change, so a new child list is the one signal that
  // the count moved. Pop the count then — a CSS animation on the count alone
  // would also play on every page load.
  (() => {
    const basket = document.getElementById('cart-icon-bubble');
    if (!basket) return;

    new MutationObserver(() => {
      basket.classList.remove('is-bumped');
      void basket.offsetWidth; // restart it if a second add lands mid-animation
      basket.classList.add('is-bumped');
    }).observe(basket, { childList: true });

    basket.addEventListener('animationend', () => basket.classList.remove('is-bumped'));
  })();

  } catch(e) { console.error(e); }
})();
})();
